import moment from 'moment';
import React from 'react';
import commonService from 'utils/commonService';

type IProps = {
  product: any;
  startDate: any;
}
const PreviewPlanTable: React.FC<IProps> = (props) => {
  const { product, startDate } = props;

  return (
    <>
      <table
        className="plan-table"
        style={{
          width: '100%',
          maxWidth: '1024px',
          marginBottom: '10px',
          textAlign: 'center'
        }}
      >
        <tr>
          <th rowSpan={2} style={{ verticalAlign: 'middle' }}>保險項目</th>
          <th rowSpan={2} colSpan={2} style={{ verticalAlign: 'middle' }}>承保範圍</th>
          <th colSpan={1}>保險金額（NT$）</th>
        </tr>
        <tr>
          <th>{product?.planName}</th>
        </tr>
        <tr>
          <td rowSpan={9} className="element__table-grid-y-title-pet" style={{ verticalAlign: 'middle' }}>寵物醫療費用</td>
          <td rowSpan={3} className="element__table-grid-y-title-pet" style={{ verticalAlign: 'middle' }}>門診費用</td>
          <td className="element__table-grid-y-title-pet">每一保險事故保險金額</td>
          <td style={{ border: '1px solid #DFDFDF' }}>{commonService.amountFormat(product?.AMOUNT1)}</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">保險期間內累積最高賠償限額</td>
          <td style={{ border: '1px solid #DFDFDF' }}>{commonService.amountFormat(product?.AMOUNT10)}</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">自負額</td>
          <td style={{ border: '1px solid #DFDFDF' }}>{product?.DEDUCTIBLE1}</td>
        </tr>
        <tr>
          <td rowSpan={3} className="element__table-grid-y-title-pet" style={{ verticalAlign: 'middle' }}>住院費用</td>
          <td className="element__table-grid-y-title-pet">每一保險事故保險金額</td>
          <td>{commonService.amountFormat(product?.AMOUNT2)}</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">保險期間內累積最高賠償限額</td>
          <td style={{ border: '1px solid #DFDFDF' }}>{commonService.amountFormat(product?.AMOUNT11)}</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">自負額</td>
          <td style={{ border: '1px solid #DFDFDF' }}>{product?.DEDUCTIBLE2}</td>
        </tr>
        <tr>
          <td rowSpan={3} className="element__table-grid-y-title-pet" style={{ verticalAlign: 'middle' }}>手術費用</td>
          <td className="element__table-grid-y-title-pet">每一保險事故保險金額</td>
          <td>{commonService.amountFormat(product?.AMOUNT3)}</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">保險期間內累積最高賠償限額</td>
          <td style={{ border: '1px solid #DFDFDF' }}>{commonService.amountFormat(product?.AMOUNT12)}</td>
        </tr>
        <tr>
          <td className="element__table-grid-y-title-pet">自負額</td>
          <td style={{ border: '1px solid #DFDFDF' }}>{product?.DEDUCTIBLE3}</td>
        </tr>
        <tr>
          <td colSpan={3} className="element__table-grid-y-title-pet">寵物侵權責任</td>
          <td>{commonService.amountFormat(product?.AMOUNT5)}</td>
        </tr>
        <tr>
          <td colSpan={3} className="element__table-grid-y-title-pet">寵物協尋廣告費用</td>
          <td>{commonService.amountFormat(product?.AMOUNT6)}</td>
        </tr>
        <tr>
          <td colSpan={3} className="element__table-grid-y-title-pet">被保險人住院期間寄宿日額費用(每日)</td>
          <td>{commonService.amountFormat(product?.AMOUNT7)}</td>
        </tr>
        <tr>
          <td colSpan={3} className="element__table-grid-y-title-pet">寵物喪葬費用</td>
          <td>{commonService.amountFormat(product?.AMOUNT8)}</td>
        </tr>
        <tr>
          <td colSpan={3} className="element__table-grid-y-title-pet">寵物重新取得費用</td>
          <td>{commonService.amountFormat(product?.AMOUNT9)}</td>
        </tr>
        <tr>
          <td colSpan={3} className="element__table-grid-y-title-pet">合計保費</td>
          <td><b>{commonService.amountFormat(product?.PREMIUM)}</b></td>
        </tr>
      </table>
      <div>預定生效日：{moment(startDate).format('YYYY年MM月DD日')}0時起，保期一年</div>
    </>
  );
};

export default PreviewPlanTable;
